import { hiddenFromIndexLink, isMobile } from '../../../utils';
import stickyHeaderInit from './stickyHeader';
import DropdownMenu from './dropdownMenu';
import MobileNavigationInit from './toggleMenu';
import './headerHoverNavigation';

document.addEventListener('DOMContentLoaded', () => {
  stickyHeaderInit();
  hiddenFromIndexLink();

  /**
   * Init when mobile viewport
   */
  if (isMobile()) {
    DropdownMenu();
    MobileNavigationInit();
  }
});
